import { FC, forwardRef, KeyboardEvent as ReactKeyboardEvent, MouseEvent as ReactMouseEvent } from 'react';
import IconButton from '../IconButton/IconButton';
import { PreviewPanelPropsTypes } from './types/propTypes';
import styles from './PreviewPanel.module.scss';

const PreviewPanel: FC<PreviewPanelPropsTypes> = forwardRef<HTMLDivElement, PreviewPanelPropsTypes>(
  ({ children, className = '', closeIcon = true, onClose }, ref) => {
    const onClosePreviewPanel = (e: ReactKeyboardEvent | ReactMouseEvent) => {
      if (onClose) {
        onClose(e);
      }
    };

    return (
      <span>
        <section className={`${styles['preview-panel-container']} ${className}`} ref={ref}>
          {closeIcon && (
            <IconButton
              containerClassName={styles['close-icon']}
              data-testid="close-icon-test-id"
              iconName={'xmark'}
              iconWithBorder={true}
              onClick={onClosePreviewPanel}
            />
          )}
          <section className={styles['panel-content']} data-testid="content-test-id">
            {children}
          </section>
        </section>
      </span>
    );
  },
);
PreviewPanel.displayName = 'PreviewPanel';
export default PreviewPanel;
